import React from 'react';
import PropTypes from 'prop-types';
import './Dashboard.css';
import { Card, CardBody, CardText, CardTitle, Col, Row } from 'reactstrap';

const Dashboard1 = () => (

    <div>
  
    <div className = ' py-2 border round mt-1 ' style={{margin :'0 2%',  boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)', borderRadius: '9px'}} >
  
    <h1 className = 'py-1  text-center'>  DASHBOARD </h1>
    
  
    <div style={{margin :'2% 2%'}}>
      <Row className = 'text-center' >
  
      
      <Col md={4}  >
      
        <Card style={{ width: '18rem', backgroundColor: '#006fff59' , border:"1px solid black"}}>
    
        <CardBody  style={{ color: 'black' }}>
          <CardTitle tag="h5" >  Total Candidates </CardTitle>
            <CardText style={{fontSize:"2.5em"}}>
              100
            </CardText>
        </CardBody>
      </Card>
    </Col>
  
    <Col md={4} >
      
        <Card style={{ width: '18rem',  border:"1px solid black", backgroundColor: '#006fff59' }}>
    
        <CardBody style={{ color: 'black' }}>
          <CardTitle tag="h5" >  Verified from the University </CardTitle>
            <CardText style={{fontSize:"2.5em"}}>  23 </CardText>
        </CardBody>
      </Card>
    </Col>
  
    <Col md={4} >
      
        <Card style={{ width: '18rem' , border:"1px solid black", backgroundColor: '#006fff59' }}>
    
        <CardBody style={{ color: 'black' }}>
          <CardTitle tag="h5"  >  Pending for Verification </CardTitle>
            <CardText style={{fontSize:"2.5em"}}>  100 </CardText>
        </CardBody>
      </Card>
    </Col>
  
  
  </Row>
  
      
    </div>
    <div>
  
    <Row className = 'text-center mt-5' >
      <Col md={2}>
  
  
      </Col>
  
    <Col md={4} >
      
      <Card style={{ width: '18rem' , border:"1px solid black",  backgroundColor: '#006fff59' }}>
  
      <CardBody style={{ color: 'black' }}>
        <CardTitle tag="h5" className = 'text-center'>  Not paid the full Course Fee </CardTitle>
          <CardText style={{fontSize:"2.5em"}}>  32 </CardText>
      </CardBody>
    </Card>
  </Col>
  
  
  
  <Col md={4}  >
      
      <Card style={{ width: '18rem' , border:"1px solid black" ,  backgroundColor: '#006fff59'}}>
  
      <CardBody style={{ color: 'black' }}>
        <CardTitle tag="h5" className = 'text-center' >  Paid the full Course Fee </CardTitle>
          <CardText style={{fontSize:"2.5em"}}>  32 </CardText>
      </CardBody>
    </Card>
  </Col>
  
  <Col md={2}>
  
        
      </Col>
    </Row>
  
    </div>
  
    </div>
    </div>
  
);

Dashboard1.propTypes = {};

Dashboard1.defaultProps = {};

export default Dashboard1
;